const getCdnImage = path => `${process.env.GATSBY_CDN_PATH}${path}`

export default getCdnImage
